export default __webpack_public_path__ + "static/media/18513-vulkan.42442490.pdf";